import { axiosHttp } from 'boot/axios'
import { Token, TokenParams } from 'src/lib/mediasoup/Model'

export async function generateToken (tokenParams: TokenParams): Promise<Token | boolean> {
  try {
    const result = await axiosHttp({
      method: 'post',
      url: '/api/v1/getToken',
      data: tokenParams
    })

    if (process.env.DEV) console.debug('Token: getToken():', result)

    if (result.status === 200) {
      return result.data.roomLink
    } else {
      return result.data
    }
  } catch (e) {
    if (process.env.DEV) console.warn(e)
    return false
  }
}

export async function leaveSession (tokenParams: TokenParams): Promise<boolean> {
  try {
    const result = await axiosHttp({
      method: 'post',
      url: '/api/v1/leaveSession',
      data: tokenParams
    })

    if (process.env.DEV) console.debug('Token: leaveSession():', result)

    return result.status === 200
  } catch (e) {
    console.error(e)
  }
}
